import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { SessionStorageService } from './session-storage.service';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  constructor(private http: HttpClient, private sessionStorageService: SessionStorageService) {}

  get roles(): string[] {
    return JSON.parse(this.sessionStorageService.getItem('user')!).roles;
  }

  hasRole(role: string): boolean {
    return JSON.parse(this.sessionStorageService.getItem('user')!).roles.includes(role);
  }

  refreshToken(token: string): Observable<any> {
    const body = {
      'refreshToken': token,
    };
    return this.http.post(`${environment.apiurl}/auth/refresh-token`, body);
  }
}
